import React from "react";
import {
	Page,
	Text,
	View,
	Document,
	StyleSheet,
	Link,
} from "@react-pdf/renderer";

const monthNames = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
];

const styles = StyleSheet.create({
	page: {
		fontFamily: "Helvetica",
		fontSize: 12,
		padding: 20,
		backgroundColor: "#f7f7f7",
	},
	header: {
		marginBottom: 20,
		textAlign: "center",
		backgroundColor: "#000000",
		padding: 10,
		borderRadius: 5,
	},
	headerText: {
		fontSize: 24,
		fontWeight: "bold",
		color: "#fff",
	},
	section: {
		marginBottom: 20,
		backgroundColor: "#fff",
		padding: 10,
		borderRadius: 5,
	},
	heading: {
		fontSize: 16,
		fontWeight: "bold",
		marginBottom: 10,
		textTransform: "uppercase",
		borderBottomWidth: 1,
		borderBottomColor: "#333",
		paddingBottom: 5,
	},
	content: {
		fontSize: 12,
		marginBottom: 10,
	},
	item: {
		marginBottom: 10,
	},
	faqQuestion: {
		fontSize: 12,
		fontWeight: "bold",
		marginBottom: 5,
		color: "#EA5E48",
	},
	abt: {
		marginTop: 10,
		color: "#FFFFFF",
		textDecoration: "none",
	},
	description: {
		marginBottom: 15,
	},
	url: {
		color: "blue",
		textDecoration: "none",
	},
});

const Itinerary = ({ tour }) => {
	return (
		<Document>
			<Page size="A4" style={styles.page}>
				<View style={styles.header}>
					<Text style={styles.headerText}>Art of Bicycle Trips</Text>
					<Text style={styles.abt}>
						www.artofbicycletrips.com | contact@artofbicycletrips.com
					</Text>
				</View>
				<View style={styles.section}>
					<Text style={styles.heading}>
						<Link
							src={`https://artofbicycletrips.com/tours/${tour.slug}/`}
							style={styles.url}
							target="_blank"
							rel="noopener noreferrer"
						>
							{tour.title}
						</Link>
					</Text>
					<View style={styles.content}>
						<Text style={styles.item}>
							<Text style={{ fontWeight: "bold" }}>Duration:</Text> {tour.duration}
						</Text>
						{/* <Text style={styles.item}>
							<Text style={{ fontWeight: "bold" }}>Price:</Text> From US${tour.price}
						</Text> */}
					</View>
				</View>
				{/* Quickfacts */}
				<View style={styles.section}>
					<Text style={styles.heading}>Quick Facts</Text>
					<Text style={styles.item}>
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>Tour start:</Text>{" "}
						{tour.quickfacts.start}
					</Text>
					<Text style={styles.item}>
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>Tour end:</Text>{" "}
						{tour.quickfacts.finish}
					</Text>
					<Text style={styles.item}>
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>Lodging:</Text>{" "}
						{tour.quickfacts.lodging}
					</Text>
					<Text style={styles.item}>
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>Level:</Text>{" "}
						{tour.quickfacts.level.split("_").join(" to ")}
					</Text>
					<Text style={styles.item}>
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>
							Avg. dist. cycled:
						</Text>{" "}
						{tour.quickfacts.avgDistance}
					</Text>
					{tour.quickfacts.flyin && (
						<Text style={styles.item}>
							<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>Fly-In:</Text>{" "}
							{tour.quickfacts.flyin}
						</Text>
					)}
					{tour.quickfacts.flyout && (
						<Text style={styles.item}>
							<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>Fly-Out:</Text>{" "}
							{tour.quickfacts.flyout}
						</Text>
					)}
					{tour.quickfacts.min && (
						<Text style={styles.item}>
							<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>Group Size:</Text>{" "}
							Min. {tour.quickfacts.min}, Max. {tour.quickfacts.max}
						</Text>
					)}
				</View>
				{/* Highlights */}
				<View style={styles.section}>
					<Text style={styles.heading}>Highlights</Text>
					{tour.highlight.map((node) => (
						<View key={node.id}>
							<Text style={styles.item}>- {node.desc}</Text>
						</View>
					))}
				</View>
				{/* Overview */}
				<View style={styles.section}>
					<Text style={styles.heading}>Overview</Text>
					<Text style={styles.item}>
						<Text style={{ fontWeight: "bold" }}>{tour.overview}</Text>
					</Text>
				</View>
				{/* Itinerary */}
				<View style={styles.section}>
					{/* <Text style={styles.heading}>Detailed Itinerary</Text> */}
					{tour.itinerary.map((node) => (
						<View key={node.id} style={styles.section}>
							<Text style={styles.heading}>
								Day {node.day} - {node.place}
							</Text>
							<View style={styles.content}>
								{node.desc && (
									<Text style={[styles.item, styles.description]}>
										<Text style={{ fontWeight: "bold" }}></Text> {node.desc}
									</Text>
								)}

								<Text style={styles.item}>
									<Text style={{ fontWeight: "bold" }}>Meals:</Text> {node.meals}
								</Text>
								<Text style={styles.item}>
									<Text style={{ fontWeight: "bold" }}>Cycling Distance:</Text>{" "}
									{node.cycDistance}
								</Text>
								{/* <Text style={styles.item}>
									<Text style={{ fontWeight: "bold" }}>Primary Activity:</Text>{" "}
									{node.activity}
								</Text> */}
								{/* {node.secActivity && (
									<Text style={styles.item}>
										<Text style={{ fontWeight: "bold" }}>Secondary Activity:</Text>{" "}
										{node.secActivity}
									</Text>
								)} */}
								{node.hotelUrl && (
									<Text style={styles.item}>
										<Text style={{ fontWeight: "bold" }}>Accommodation:</Text>{" "}
										<Link
											src={node.hotelUrl}
											style={styles.url}
											target="_blank"
											rel="noopener noreferrer"
										>
											{node.hotel}
										</Link>
									</Text>
								)}
							</View>
						</View>
					))}
				</View>
				{/* What to Expect */}
				{tour.straight && (
					<View style={styles.section}>
						<Text style={styles.heading}>What to Expect</Text>
						<Text style={styles.content}>
							We want you to have a fantastic experience on your tour, so we aim to be
							upfront about what to expect along the way. Here are key details to keep
							in mind:
						</Text>
						<Text>{tour.straight}</Text>
					</View>
				)}

				{/* Arrival & Departure Details */}
				{tour.arrival && (
					<View style={styles.section}>
						<Text style={styles.heading}>Arrival & Departure Details</Text>
						<Text>{tour.arrival}</Text>
					</View>
				)}
				{/* Weather */}
				{tour.weather && (
					<View style={styles.section}>
						<Text style={styles.heading}>Weather</Text>
						<Text style={styles.item}>
							<Text style={{ fontWeight: "bold" }}>{tour.weather}</Text>
						</Text>
					</View>
				)}
				{/* more season */}
				{/* Weather */}
				{tour.season && (
					<View style={styles.section}>
						<Text style={styles.heading}>Seasonality</Text>
						{tour.season.length > 0 && (
							<View style={{ marginBottom: 20 }}>
								{tour.season.map((weather, index) => (
									<View
										key={index}
										style={{ padding: 5, flexDirection: "row", alignItems: "center" }}
									>
										<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>
											{monthNames[index]}:
										</Text>
										<Text style={{ marginLeft: 5 }}>{weather.type}</Text>
									</View>
								))}
							</View>
						)}
					</View>
				)}

				{/* What to Pack */}
				<View style={styles.section}>
					<Text style={styles.heading}>What to Pack</Text>
					<Text style={styles.content}>
						Packing smart is essential for a safe and enjoyable cycling adventure.
						From enessential biking gear to clothing and travel necessities, this
						guide ensures you're prepared for any terrain or climate.
					</Text>

					<Text style={{ fontWeight: "bold", marginBottom: 5, color: "#EA5E48" }}>
						Recommended Bicycling Clothes & Gear
					</Text>
					<Text style={styles.content}>
						• Bicycling shoes or stiff-soled sneakers.
					</Text>
					<Text style={styles.content}>• Padded cycling shorts.</Text>
					<Text style={styles.content}>
						• Short-fingered cycling gloves (personal gloves are ideal).
					</Text>
					<Text style={styles.content}>
						• Brightly colored cycling jerseys or synthetic T-shirts for visibility.
					</Text>
					<Text style={styles.content}>• Synthetic cycling socks.</Text>
					<Text style={styles.content}>• Sunglasses with UV protection.</Text>
					<Text style={styles.content}>
						• Personal helmet (recommended even though provided).
					</Text>
					<Text style={styles.content}>
						• Personal saddle (optional for added comfort).
					</Text>
					<Text style={styles.content}>• Rain jacket or windbreaker.</Text>
					<Text style={styles.content}>
						• Cycling water bottle (to reduce plastic waste).
					</Text>
					<Text style={styles.content}>
						Note: Helmets, gloves, and water bottles are personal items, so bringing
						your own is recommended for maximum comfort and hygiene.
					</Text>

					<Text style={{ fontWeight: "bold", marginBottom: 5, color: "#EA5E48" }}>
						Clothing
					</Text>
					<Text style={styles.content}>
						• Light, breathable fabrics like cotton or linen.
					</Text>
					<Text style={styles.content}>
						• Full-sleeved clothing for sun protection.
					</Text>
					<Text style={styles.content}>
						• Warm layers for chilly mornings and evenings (if traveling in winter).
					</Text>
					<Text style={styles.content}>
						• Comfortable footwear for non-cycling time.
					</Text>
					<Text style={styles.content}>
						• Bring a compact rain jacket in case of sudden weather changes.
					</Text>
					<Text style={styles.content}>
						• Ethnic or modest clothing for exploring towns and temples.
					</Text>

					<Text style={{ fontWeight: "bold", marginBottom: 5, color: "#EA5E48" }}>
						Other Necessities
					</Text>
					<Text style={styles.content}>
						• Toiletries: Basic hygiene essentials, including insect/mosquito
						repellent and sunscreen.
					</Text>
					<Text style={styles.content}>• Hand sanitizer and wet wipes.</Text>
					<Text style={styles.content}>• Plug socket adaptor.</Text>
					<Text style={styles.content}>
						• Binoculars for wildlife spotting or desert landscapes.
					</Text>

					<Text style={{ fontWeight: "bold", marginBottom: 5, color: "#EA5E48" }}>
						Pro Tips
					</Text>
					<Text style={styles.content}>
						• Pack light but plan for the varying temperatures: warm days, chilly
						evenings, and desert winds.
					</Text>
					<Text style={styles.content}>
						• Use brightly colored clothing for visibility on roads.
					</Text>
					<Text style={styles.content}>
						• Pack light to leave room for shopping.
					</Text>

					<Text style={{ fontWeight: "bold", marginBottom: 5, color: "#EA5E48" }}>
						Luggage
					</Text>
					<Text style={styles.content}>
						Please limit your luggage to one soft-sided medium-sized suitcase and one
						carry-on bag. Mark your luggage with your name, address, and phone number.
					</Text>
				</View>
				{/* Visa Information */}
				<View style={styles.section}>
					<Text style={styles.heading}>Visa Information</Text>
					<Text style={styles.content}>
						Before venturing on your adventure, make sure you're equipped with
						essential travel advice, including security updates, local laws, and
						crucial passport and visa information. Start by visiting the official
						government website of your home country for accurate and reliable
						guidance:
					</Text>
					<Text style={styles.content}>
						•{" "}
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>
							UK Residents:
						</Text>{" "}
						Stay informed by reviewing the{" "}
						<Link
							src="https://www.gov.uk/foreign-travel-advice"
							style={styles.url}
							target="_blank"
							rel="noopener noreferrer"
						>
							Foreign, Commonwealth & Development Office (FCDO) Travel Advice.
						</Link>
					</Text>
					<Text style={styles.content}>
						•{" "}
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>
							US Residents:
						</Text>{" "}
						Access vital travel tips and updates through the{" "}
						<Link
							src="https://travel.state.gov/content/travel/en/international-travel/International-Travel-Country-Information-Pages.html"
							style={styles.url}
							target="_blank"
							rel="noopener noreferrer"
						>
							US Department of State Travel Advice.
						</Link>
					</Text>
					<Text style={styles.content}>
						•{" "}
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>
							Australian Residents:
						</Text>{" "}
						Plan ahead with the latest updates on the{" "}
						<Link
							src="https://www.smartraveller.gov.au/"
							style={styles.url}
							target="_blank"
							rel="noopener noreferrer"
						>
							Smart Traveller website.
						</Link>
					</Text>
					<Text style={styles.content}>
						•{" "}
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>
							Canadian Residents:
						</Text>{" "}
						Find comprehensive travel and visa guidance on the{" "}
						<Link
							src="https://travel.gc.ca/travelling/advisories"
							style={styles.url}
							target="_blank"
							rel="noopener noreferrer"
						>
							Government of Canada's Travel Advice and Advisories.
						</Link>
					</Text>
					<Text style={styles.content}>
						•{" "}
						<Text style={{ fontWeight: "bold", color: "#EA5E48" }}>
							Residents of Other Countries:
						</Text>{" "}
						Check with your government or local consulate for tailored travel advice
						and requirements.
					</Text>
					<Text style={styles.content}>
						<Text style={{ fontStyle: "italic" }}>Note:</Text> Passport and visa
						regulations can change at any time. Stay proactive by checking for the
						latest updates to ensure a smooth and stress-free journey.
					</Text>
				</View>

				{/* Visa */}
				{/* {tour.visa && (
					<View style={styles.section}>
						<Text style={styles.heading}>Visa</Text>
						<Text style={styles.item}>
							<Text style={{ fontWeight: "bold" }}>{tour.visa}</Text>
						</Text>
					</View>
				)} */}
				{/* Travel Insurance */}
				<View style={styles.section}>
					<Text style={styles.heading}>Travel Insurance</Text>

					<Text style={styles.content}>
						It is a mandatory requirement to purchase adequate travel insurance in
						order to participate in our tours and protect yourself from unforeseen
						events. Our experience shows that guests who purchase travel
						insurance—including coverage for trip cancellation, interruption, delay,
						baggage damage, loss or theft, personal accident, death and repatriation
						costs, medical and emergency expenses (including Covid-19), and personal
						liability—travel with greater peace of mind.
					</Text>

					<Text style={{ fontWeight: "bold", marginTop: 10 }}>
						Can I use my credit card insurance?
					</Text>
					<Text style={styles.content}>
						Yes, as long as it meets our requirements and provides adequate coverage.
						Ensure you have an emergency contact number and policy number available.
					</Text>

					<Text style={{ fontWeight: "bold", marginTop: 10 }}>
						When should I buy travel insurance?
					</Text>
					<Text style={styles.content}>
						Purchase travel insurance as soon as you've paid in full or booked your
						flights.
					</Text>

					<Text style={{ fontWeight: "bold", marginTop: 10 }}>
						Is proof of travel insurance required?
					</Text>
					<Text style={styles.content}>
						Yes. You must provide your insurer's name, policy number, and emergency
						contact via our reservation form. This is mandatory. If you cannot provide
						proof, you’ll need to purchase insurance before traveling with us.
					</Text>

					<Text style={{ fontWeight: "bold", marginTop: 10 }}>
						Does Art of Bicycle Trips sell travel insurance?
					</Text>
					<Text style={styles.content}>
						We do not sell travel insurance directly, as we believe our customers
						should have the freedom to choose a policy that best suits their needs.
						However, we recommend
						<Link
							src="https://insurednomads.com/?ref=pankaj"
							style={styles.url}
							target="_blank"
							rel="noopener noreferrer"
						>
							{" "}
							Insured Nomads
						</Link>
						<Text> as a great starting point.</Text>
					</Text>
				</View>

				{/* FAQ Section */}
				{tour.faqss?.faq?.length > 0 && (
					<View style={styles.section}>
						<Text style={styles.heading}>Frequently Asked Questions</Text>
						{tour.faqss.faq.map((faq, index) => (
							<View key={index} style={styles.item}>
								<Text style={styles.faqQuestion}>{faq.question}</Text>
								<Text>{faq.answer}</Text>
							</View>
						))}
					</View>
				)}
			</Page>
		</Document>
	);
};

export default Itinerary;
